import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import CollectionContMain from "presentation/view/container/Collection/CollectionContMain";

CommonEntrypoint(<CollectionContMain />)